import * as yup from "yup";

import { validator as circumstancesDataValidator } from "./CircumstancesData/validator";
import { validator as otherPersonsDataValidator } from "./OtherPersonsData/validator";
import { validator as statementsDataValidator } from "./StatementsData/validator";

export const validator = yup.object({
  ...circumstancesDataValidator,
  ...statementsDataValidator,
  ...otherPersonsDataValidator,
});
